import {PremiumSiteLayout} from '@app/web-player/premium/premium-site-layout';

export function PlaceholderPage({name}: {name: string}) {
  return (
    <PremiumSiteLayout title={name}>
      <div className="flex flex-1 items-center justify-center px-6 text-center text-lg text-white">
        {`Placeholder for ${name}`}
      </div>
    </PremiumSiteLayout>
  );
}
